<template>
  <div class="mobile" ref="mobile" @wheel="mobileScroll">
    <div class="top top-fixed" @touchend.stop>
      <img class="left" src="../images/logo-big.png" alt="">
      <img class="right" src="../images/menu.png" alt="" @click="topOpen = true">
    </div>
    <div class="top-open" v-if="topOpen">
      <div class="title">
        <img class="left" src="../images/logo-big.png" alt="" @touchend.stop>
        <img class="right" src="../images/close.png" alt="" @click="topOpen = false">
      </div>
      <div class="menus">
        <p :class="{'current': scrollIndex === 0}" @click="scrollToPage(0)">善版无影AI学习电脑</p>
        <p :class="{'current': scrollIndex === 1}" @click="scrollToPage(1)">善版智能学习书 </p>
        <p :class="{'current': scrollIndex === 2}" @click="scrollToPage(2)">善版知盟</p>
        <p :class="{'current': scrollIndex >= 3}" @click="scrollToPage(3)">善版优质内容浏览器</p>
      </div>
    </div>
    <div class="dots">
      <div class="dot" :class="{'current': scrollIndex === 0}" @click="scrollToPage(0)"></div>
      <div class="dot" :class="{'current': scrollIndex === 1}" @click="scrollToPage(1)"></div>
      <div class="dot" :class="{'current': scrollIndex === 2}" @click="scrollToPage(2)"></div>
      <div class="dot" :class="{'current': scrollIndex >= 3}" @click="scrollToPage(3)"></div>
    </div>
    <div class="banner banner1">
      <img v-intersect class="img1-1" src="../images/t1.png" alt="">
      <img v-intersect class="img1-2" src="../images/t2.png" alt="">
    </div>
    <div class="banner banner2">
      <img v-intersect class="img2-1" src="../images/logo-big.png" alt="">
      <p v-intersect class="text2-1">借助AI智能生产工具<br/>研发面向终身学习各学段的智能学习书</p>
      <img v-intersect class="img2-2" src="../images/m-t7.png" alt="">
    </div>
    <div class="banner banner3">
      <img v-intersect class="img3-1" src="../images/t4.png" alt="">
      <img v-intersect class="img3-2" src="../images/m-t6.png" alt="">
      <p v-intersect class="text3-1">善版知盟（SKSA,Shanban Knowledge Service Alliance ）是善版云知识服务生态联盟，旨在与合作伙伴一起，推进数智出版产业发展，为用户打造极致性价比的终身学习产品，让每一位学习者都能享有学习的权利，把优质学习内容带给每一位学习者。</p>
    </div>
    <div class="banner banner4">
      <div class="content" v-intersect>
        <img class="img4-1" src="../images/logo-small.png" alt="">
        <img class="img4-2" src="../images/t5.png" alt="">
        <img class="img4-3" src="../images/code.png" alt="">
        <p class="text4-1">让优质学习内容触手可及</p>
        <p class="text4-2">善版云App是一款专注于优质学习内容的浏览器。用户通过善版云App可以访问合作出版社的官网，浏览出版社官网的智能学习书以及其他丰富的数字学习内容。善版云App通过严格的内容筛选只允许用户访问指定的优质学习内容，进而为用户提供纯净安全的学习体验。同时，善版云App通过AI智能技术，为用户提供多种多样的学习互动模块、科学合理的学习路径规划以及有趣高效的学习激励系统，帮助用户大幅提升学习效果。</p>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <p>Copyright © 2024 北京善版科技有限公司</p>
        <p>京公网安备 11010802041724号</p>
        <p style="cursor: pointer;" @click="toBeiAn">京ICP备2023005786号</p>
        <p>增值电信业务经营许可证：京B2-20243662</p>
        <p>隐私声明</p>
        <p>关于cookies</p>
        <p>联系我们</p>
        <p>地址：北京市海淀区中关村大街22号5层508</p>
      </div>
      <div class="right">
        <p class="tel"><img src="../images/tel.png" alt="">400-998-0026</p>
        <img class="lianxi" src="../images/lianxi.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',
  directives: {
    // 自定义指令, 滚动到指定位置
    intersect: {
      bind(el) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add('fade-in-animation')
                // 如果你希望动画只播放一次，取消下面的注释
                // observer.unobserve(el)
              } else {
                // 当元素离开视图区域后，移除动画类，以便再次进入时重新触发动画
                el.classList.remove('fade-in-animation')
              }
            })
          }
        )
        observer.observe(el)
      }
    }
  },
  data() {
    return {
      topOpen: false,
      scrollIndex: 0, // 上次滚动条位置
      isScrolling: false
    }
  },
  watch: {
    // 监听滚动条位置
    scrollIndex(val) {
      this.isScrolling = true
      if (window.mobileScrollChangeTimer) {
        clearTimeout(window.mobileScrollChangeTimer)
      }
      window.mobileScrollChangeTimer = setTimeout(() => {
        this.isScrolling = false
        window.mobileScrollChangeTimer = null
      }, 500)
      this.$refs.mobile.scrollTo({
        top: document.documentElement.clientHeight * val,
        behavior: 'smooth'
      })
    }
  },
  mounted() {
    setTimeout(() => {
      let touchStartY = 0
      let touchEndY = 0
      this.$refs.mobile.addEventListener('touchstart', (event) => {
        touchStartY = event.touches[0].clientY
      }, { passive: false })
      this.$refs.mobile.addEventListener('touchmove', (event) => {
        event.preventDefault()
      }, { passive: false })
      this.$refs.mobile.addEventListener('touchend', (event) => {
        touchEndY = event.changedTouches[0].clientY
        const deltaY = touchEndY - touchStartY
        if (Math.abs(deltaY) > 20) {
          this.mobileScroll({ deltaY })
        }
      })
    }, 100);
  },
  methods: {
    // mobile滚动事件
    mobileScroll(e) {
      if (e.preventDefault) {
        e.preventDefault()
        e = { deltaY: -e.deltaY }
      }
      if (this.isScrolling) {
        return
      }
      if (e.deltaY < 0) {
        // 向下滚动
        if (this.scrollIndex < 4) {
          this.scrollIndex++
        }
      } else {
        // 向上滚动
        if (this.scrollIndex > 0) {
          this.scrollIndex--
        }
      }
    },
    scrollToPage(index) {
      this.topOpen = false
      this.scrollIndex = index
    },
    toBeiAn() {
      window.open('https://beian.miit.gov.cn/', '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(0.3rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.fade-in-animation {
  animation: fadeIn 1s forwards;
}
@keyframes topShow {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
.mobile {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .top {
    z-index: 100;
    left: 0;
    top: 0;
    right: 0;
    height: 1.03rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0rem 0.45rem 0rem 0.5rem;
    background-color: transparent;
    &.top-absolute {
      position: absolute;
    }
    &.top-fixed {
      position: fixed;
      // background-color: rgba(0, 0, 0, 0.7);
      animation: topShow 0.3s forwards;
    }
    .left {
      width: 1.25rem;
    }
    .right {
      width: 0.39rem;
    }
  }
  .top-open {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    height: 100vh;
    z-index: 200;
    overflow: hidden;
    background-image: url(../images/open-bg.png);
    background-size: cover;
    .title {
      height: 1.03rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0rem 0.4rem 0rem 0.5rem;
      .left {
        width: 1.25rem;
      }
      .right {
        width: 0.29rem;
      }
    }
    .menus {
      color: rgba(254, 254, 254, 0.37);
      font-size: 0.25rem;
      line-height: 0.25rem;
      p {
        padding: 0.38rem 0rem;
        text-align: center;
        border-top: 0.01rem solid rgba(255, 255, 255, 0.22);
        cursor: pointer;
        &.current {
          color: #fefefe;
        }
        &:hover {
          color: #fefefe;
        }
      }
    }
  }
  .dots {
    position: fixed;
    right: 0.3rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    z-index: 10;
    .dot {
      width: 0.1rem;
      height: 0.1rem;
      background-color: #fff;
      border-radius: 50%;
      margin-bottom: 0.2rem;
      cursor: pointer;
      opacity: 0.15;
      &.current {
        opacity: 0.7;
      }
    }
  }
  .banner {
    position: relative;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &.banner1 {
      // background-image: url(../images/m-bg1.png);
      background-image: url('https://zhledu.cdn.bcebos.com/english/resource/1726474655090.png');
      .img1-1 {
        width: 6.79rem;
      }
      .img1-2 {
        width: 6.5rem;
        margin-top: 40vh;
      }
    }
    &.banner2 {
      // background-image: url(../images/m-bg2.png);
      background-image: url('https://zhledu.cdn.bcebos.com/english/resource/1726474662731.png');
      padding-top: 5vh;
      .img2-1 {
        width: 2.26rem;
      }
      .text2-1 {
        color: #fefefe;
        font-weight: bold;
        font-size: 0.32rem;
        line-height: 0.43rem;
        margin-top: 0.25rem;
        text-align: center;
      }
      .img2-2 {
        width: 12rem;
        margin-top: 28vh;
      }
    }
    &.banner3 {
      // background-image: url(../images/m-bg3.png);
      background-image: url('https://zhledu.cdn.bcebos.com/english/resource/1726474668875.png');
      padding-top: 10vh;
      .img3-1 {
        width: 4.2rem;
      }
      .img3-2 {
        width: 6.4rem;
        margin-top: 33vh;
        margin-bottom: 0.64rem;
      }
      .text3-1 {
        color: #fff;
        font-size: 0.19rem;
        line-height: 0.29rem;
        width: 6.39rem;
        text-align: justify;
        letter-spacing: 0.01rem;
      }
    }
    &.banner4 {
      // background-image: url(../images/m-bg4.png);
      background-image: url('https://zhledu.cdn.bcebos.com/english/resource/1726474675453.png');
      justify-content: flex-end;
      .content {
        width: 100%;
        padding-left: 0.54rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        .img4-1 {
          width: 1.86rem;
        }
        .img4-2 {
          width: 3.93rem;
          margin-top: 0.36rem;
        }
        .img4-3 {
          position: absolute;
          right: 0.56rem;
          width: 1.34rem;
          bottom: 2.55rem;
        }
        .text4-1 {
          font-size: 0.4rem;
          margin-top: 0.43rem;
          color: white;
        }
        .text4-2 {
          margin-top: 0.28rem;
          margin-bottom: 0.66rem;
          font-size: 0.19rem;
          line-height: 0.29rem;
          color: rgba(255, 255, 255, 0.7);
          width: 6.36rem;
          text-align: justify;
        }
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    height: 2.8rem;
    background-color: #1F1F1F;
    padding: 0.45rem 0.61rem 0.5rem 0.56rem;
    box-sizing: border-box;
    .left {
      flex: 1;
      color: #9A9A9A;
      font-size: 0.17rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
    }
    .right {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
      .tel {
        display: flex;
        align-items: center;
        font-size: 0.19rem;
        color: #9A9A9A;
        img {
          width: 0.23rem;
          margin-right: 0.05rem;
        }
      }
      .lianxi {
        width: 1.7rem;
      }
    }
  }
}
</style>
